import { Loader } from "components/Loader";
import { BillList } from "pages/BillListPage/components/BillList";
import React, { memo } from "react";
import { useAppSelector } from "reduxUtils/hook";
import { selectIsAccountActive } from "selectors/currentAccountSelector";
import { selectInvoiceFetchingStatus } from "selectors/invoicesSelector";

export const AllBillsSection: React.FC<{
  storedTimelineBills: InvoiceSummary[];
  isTimelineFetching: boolean;
}> = memo(({ storedTimelineBills, isTimelineFetching }) => {
  const { billingEntityData } = useAppSelector(
    (store) => store.billingEntityData,
  );

  const isAccountActive = useAppSelector(selectIsAccountActive);
  const isLatestInvoicesFetching = useAppSelector(selectInvoiceFetchingStatus);
  return (
    <nav>
      <ul className="customer_tools_list">
        {isLatestInvoicesFetching && isAccountActive && (
          <li className="loading-section" data-testid="list-loading-indicator">
            <Loader />
          </li>
        )}
        {!isLatestInvoicesFetching && (
          <>
            {billingEntityData && (
              <BillList
                bills={
                  // due to (1*), the first item in new invoice array will be duplicated,
                  // so remove duplicated item before render
                  storedTimelineBills.filter(
                    (invoice, index, self) =>
                      index === self.findIndex((i) => i.id === invoice.id),
                  )
                }
              />
            )}
            <li
              className={
                isTimelineFetching
                  ? "loading-section"
                  : "loading-section--invisible"
              }
              data-testid="timeline-fetching-loading-indicator"
            >
              <Loader />
            </li>
          </>
        )}
      </ul>
    </nav>
  );
});
